import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { Spinner } from "components/common";
import { Button } from "components/bootstrap";
import { Col, Row, DataWell } from "common/components/layout-styles";
import { useGetDecoratedEventProcedure } from "security-app/hooks/useEventProceduresAPI";
import useGetPermissionsByScope from "hooks/useScopePermissions";
import EventProcedureDetailsView from "../EventProcedureDetailsView";
function EventProcedureSummary({
  eventProcedureId,
  eventId = void 0,
  canEdit = false,
  onRemove = void 0,
  onEdit = void 0,
  row = false
}) {
  const { t } = useTranslation("enterprise_security_events");
  const { eventProcedure, loadingEventProcedure } = useGetDecoratedEventProcedure(eventProcedureId, eventId);
  const { scopePermissions } = useGetPermissionsByScope(eventProcedure);
  const handleRemove = useCallback(() => onRemove == null ? void 0 : onRemove(), [onRemove]);
  const handleEdit = useCallback(() => onEdit == null ? void 0 : onEdit(), [onEdit]);
  if (loadingEventProcedure) return /* @__PURE__ */ React.createElement(Spinner, { text: t("summary.loading") });
  return /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("h2", { style: { whiteSpace: "break-spaces" } }, (eventProcedure == null ? void 0 : eventProcedure.title) || /* @__PURE__ */ React.createElement("i", null, t("summary.no_title"))), /* @__PURE__ */ React.createElement(
    EventProcedureDetailsView,
    {
      eventProcedure,
      descriptionMaxHeight: row ? 400 : 250,
      row,
      eventId
    }
  ), canEdit && /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", bsStyle: "danger", onClick: handleRemove }, t("summary.remove")), (scopePermissions == null ? void 0 : scopePermissions.is_mutable) && /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", bsStyle: "primary", onClick: handleEdit }, t("summary.edit")))));
}
export default EventProcedureSummary;
